<mat-toolbar class="subtitulo">Planejamento de Oficinas</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <div fxLayout="column" fxFlex="100" fxFlexOffset="20px">
                    <mat-form-field>
                        <input #descricao matInput maxlength="200" name="descricao" placeholder="Nome da Oficina"
                               [(ngModel)]="filtro.descricao">
                        <mat-hint align="end">{{ descricao.value.length }} / 200</mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <div ngModelGroup="comboProjeto" fxFlex="60">
                    <combo-projeto [showDisplayId]="false"
                                   [obrigatorio]="false"
                                   [selecionado]="filtro.projeto"
                                   (valorChange)="onValorChangeProjeto($event)">
                    </combo-projeto>
                </div>
                <mat-form-field style="margin-left: 20px" fxFlex="20">
                    <input matInput name="dataInicioExecucao" [matDatepicker]="dataInicioExecucao"
                           placeholder="Data de Início"
                           [(ngModel)]="filtro.dataInicio" (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataInicioExecucao"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioExecucao></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxFlex="20%">
                    <input matInput name="dataFimExecucao" [matDatepicker]="dataFimExecucao" placeholder="Data Fim"
                           [(ngModel)]="filtro.dataFim" (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataFimExecucao"></mat-datepicker-toggle>
                    <mat-datepicker #dataFimExecucao></mat-datepicker>
                </mat-form-field>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                 fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()" [disabled]="formConsultar.invalid">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()">
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef> Oficina</th>
                <td mat-cell *matCellDef="let element"> {{ element.descricao }}</td>
            </ng-container>

            <ng-container matColumnDef="datainicio">
                <th mat-header-cell *matHeaderCellDef> Data de Início</th>
                <td mat-cell *matCellDef="let element"> {{ element.dataInicio | dataSimples }}</td>
            </ng-container>

            <ng-container matColumnDef="datafim">
                <th mat-header-cell *matHeaderCellDef> Data de Fim</th>
                <td mat-cell *matCellDef="let element"> {{ element.dataFim | dataSimples }}</td>
            </ng-container>

            <ng-container matColumnDef="maxparticipantes">
                <th mat-header-cell *matHeaderCellDef> Máximo participantes</th>
                <td mat-cell *matCellDef="let element"> {{ element.maximoParticipantes }}</td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações</th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>{{ perfilAcesso.altera ? 'edit' : 'search' }}</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.altera"
                            mat-button
                            (click)="aprovar(element)"
                            [matTooltip]="'Adicionar essa atividade às turmas selecionadas'"
                            [color]="'primary'">
                        {{ 'Aprovar' }}
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{ msg }}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova oficina" mat-fab color="primary"
                    [routerLink]="menu ? ['/', menu, 'oficinaturmas', 'cadastrar'] : ['/oficinaturmas', 'cadastrar']"
                    routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
